export default "__VITE_ASSET__5$xW8_lB__"